function Tab({ title, activeTab, onChange, badge }) {
  return (
    <div className="relative inline-block">
      <button
        className={`py-3 px-6 rounded-md font-medium text-base transition-colors duration-200 ease-in-out
          ${
            activeTab
              ? "bg-dark-blue-200 text-white shadow-sm focus:ring-0"
              : "bg-gray-100 text-gray-700 hover:bg-gray-600 hover:text-white"
          } focus:outline-none focus-visible:ring-2 focus-visible:ring-dark-blue-200 focus-visible:ring-offset-2`}
        type="button"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onChange();
        }}
      >
        {title}
      </button>
      {badge ? (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute -top-2 -right-2 rotate-12 bg-amber-400 text-white text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded shadow-sm"
        >
          {badge}
        </span>
      ) : null}
    </div>
  );
}

export default function TabNav({ tabs, onChange, activeTab, badges = {} }) {
  return (
    <div className="flex flex-row mt-4 gap-2">
      {tabs.map((tab, idx) => (
        <Tab
          title={tab}
          activeTab={activeTab === tab}
          onChange={() => onChange(tab)}
          badge={badges[tab]}
          key={idx}
        />
      ))}
    </div>
  );
}
